import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Tabs, Tab, Typography, Box } from '@mui/material';
import Page from '../../../../components/Page';
import HeaderBreadcrumbs from '../../../../components/HeaderBreadcrumbs';
import DepositsData from './depositsData';

const Deposits = () => {
  const [activeTab, setActiveTab] = useState(0);

  // Handling Change when tab is changed
  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  // console.log('table data', tableData);

  return (
    <Page title="Deposits Report">
      <HeaderBreadcrumbs
        heading="Deposits Report"
        links={[{ name: 'Deposits' }]}
      />
      <Box sx={{ width: '100%' }}>
        <DepositsData />
      </Box>
    </Page>
  );
};

export default Deposits;
